// filters
export const QUERY_KEY_FILTER = 'common-filter';
export const QUERY_KEYS_CUSTOM_TAG_FILTER = [QUERY_KEY_FILTER, 'monitoring-filter-custom-tags'];
export const QUERY_KEYS_SHIP_FROM_FILTER = [QUERY_KEY_FILTER, 'get-all-ship-from'];
export const QUERY_KEYS_TEST_PURCHASE_PROGRESS_FILTER = [QUERY_KEY_FILTER, 'tp-progress-filter'];
